// extracted by mini-css-extract-plugin
module.exports = {"tag":"PriceTag_tag__2hcuT"};